import React, { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  Stack,
  Breadcrumbs,
  Select,
} from "@mui/material";
import Base from "../admin_components/Admin_Base";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import Swal from "sweetalert2";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import authAxios from "../Auth/useAxios";
// import Select from "react-select";
import ReactSelect from "react-select";
import "../CustomerProperty/CustomerProperty.css";

const AddCustomerProperty = () => {
  const [customers, setCustomers] = useState([]);
  // const [properties, setProperties] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [filteredPhases, setFilteredPhases] = useState([]);
  const [filteredPlots, setFilteredPlots] = useState([]);
  const [incentivelist, setIncentiveList] = useState([]);
  const [selectedIncentive, setSelectedIncentive] = useState("");
  const [formData, setFormData] = useState({
    mobileNumber: "",
    fatherName: "",
    address: "",
    rst: "",
    groupName: "",
    propertyPhase: "",
    plotPurchased: "",
    totalPlotAmount: "",
    selectedEmiMonths: "",
    amountPaid: "",
    totalEmisPaid: "",
    plotPurchasedDate: "",
    remainingAmount: "",
    customerType: "",
    customerId: "",
    plotId: "",
    incentivePlan: "",
  });
  // const api = useApi();
  const filteredGroups = [
    ...new Set(areaData.map((plot) => plot.area?.groupName).filter(Boolean)),
  ];

  useEffect(() => {
    if (selectedGroupName) {
      const filteredData = areaData.filter(
        (plot) => plot.area?.groupName === selectedGroupName
      );

      const uniquePhases = [...new Set(filteredData.map((item) => item.phase))];

      setFilteredPhases(uniquePhases);
      setFilteredPlots([]);
      setFormData({ ...formData, propertyPhase: "", plotPurchased: "" });
    }
  }, [selectedGroupName, areaData]);

  useEffect(() => {
    if (formData.propertyPhase) {
      const plots = areaData.filter(
        (plot) =>
          plot.area?.groupName === selectedGroupName &&
          plot.phase === formData.propertyPhase
      );

      setFilteredPlots(plots);
    }
  }, [formData.propertyPhase, selectedGroupName, areaData]);

  const handleGroupNameChange = (event) => {
    setSelectedGroupName(event.target.value);
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await authAxios.get(
          `${ADMIN_API_BASE_URL}/main/admin/list-customers`
        );
        setCustomers(response.data);
        console.log("customerslist", response.data);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    if (selectedCustomer) {
      const fetchCustomerDetails = async () => {
        try {
          const response = await authAxios.get(
            `${ADMIN_API_BASE_URL}/main/admin/list-customers`
          );
          const selectedCustomerData = response.data.find(
            (customer) => customer.customerId === selectedCustomer
          );

          if (selectedCustomerData) {
            setFormData({
              ...formData,
              groupName: selectedCustomerData.groupName || "",
              mobileNumber: selectedCustomerData.mobileNumber || "",
              fatherName: selectedCustomerData.fatherName || "",
              address: selectedCustomerData.city || "",
              rst: `${selectedCustomerData.employee?.fullName || ""} - ${
                selectedCustomerData.employee?.employeeReferenceId || ""
              }`,
            });
          }
        } catch (error) {
          console.error("Error fetching customer details:", error);
        }
      };

      fetchCustomerDetails();
    }
  }, [selectedCustomer]);

  useEffect(() => {
    const fetchAreaData = async () => {
      try {
        const response = await authAxios.get(
          `${ADMIN_API_BASE_URL}/main/admin/get-all-plots`
        );
        setAreaData(response.data);
        console.log("groupname", response.data);
      } catch (error) {
        console.error("Error fetching area data:", error);
      }
    };

    fetchAreaData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (name === "plotPurchased") {
        const selectedPlot = areaData.find((plot) => plot.id === value);
        updatedData.totalPlotAmount = selectedPlot
          ? selectedPlot.plotAmount
          : "";
      }

      if (name === "amountPaid") {
        const totalAmount = parseFloat(updatedData.totalPlotAmount) || 0;
        const amountPaid = parseFloat(value) || 0;
        updatedData.remainingAmount = (totalAmount - amountPaid).toFixed(2);
      }

      return updatedData;
    });
  };

  useEffect(() => {
    fetchPercentageHistory();
  }, []);

  const fetchPercentageHistory = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-incentives`
      );
      setIncentiveList(response.data);
    } catch (error) {
      console.error("Error fetching incentives:", error);
    }
  };
  const handleCustomerPropertyAdd = async () => {
    const formattedData = {
      customer: {
        customerId: selectedCustomer,
      },
      plots: {
        id: formData.plotPurchased,
      },
      purchaseDate: formData.plotPurchasedDate,
      customerPropertyEnum: "PENDING",
      amountPaid: parseFloat(formData.amountPaid) || 0,
      emiPaid: parseInt(formData.totalEmisPaid) || 0,
      remainingAmount: parseFloat(formData.remainingAmount) || 0,
      selectedEmiMonths: parseInt(formData.selectedEmiMonths) || 0,
      emiStartDate: formData.emiStartDate,
      emiEndDate: formData.emiEndDate,
      emiAmount: parseFloat(formData.emiAmount) || 0,
    };

    try {
      const response = await authAxios.post(
        `${ADMIN_API_BASE_URL}/main/admin/add-customer-property`,
        formattedData,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("addcustomerproperty", response.data);

      if (response.status === 201 || response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Customer property added successfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error adding customer property:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message || "Failed to add customer property.",
      });
    }
  };

  const options = customers.map((customer) => ({
    value: customer.customerId,
    label: customer.customerName,
  }));
  console.log("Selected Group Name:", selectedGroupName);
  console.log(
    "Filtered Groups:",
    [...new Set(areaData.map((plot) => plot.area?.groupName))].filter(Boolean)
  );

  console.log(selectedCustomer, "selected customer Id");
  return (
    <Base>
      <div
        className="pt-3 mt-5 res_container"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          className="admin_navigation"
        >
          <Link
            underline="hover"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="none"
            color="inherit"
            href="/admin/customer_property_list"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Add Customer Property
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">
        Add Customer Property
      </h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "90%" }} />
      </div>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "15px",
        }}
      >
        <Box
          sx={{
            padding: 3,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 3,
            width: "100%",
            maxWidth: 500,
          }}
        >
          <Stack spacing={2}>
            
              <FormControl fullWidth className="custom-react-select">
                <ReactSelect
                  classNamePrefix="react-select"
                  value={
                    options.find(
                      (option) => option.value === selectedCustomer
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedCustomer(selectedOption.value)
                  }
                  options={options}
                  placeholder="Select Customer"
                  isSearchable
                />
              </FormControl>
           

            <TextField
              label="Group Name"
              fullWidth
              name="groupName"
              value={formData.groupName}
              disabled
            />
            <TextField
              label="Mobile Number"
              fullWidth
              name="mobileNumber"
              value={formData.mobileNumber}
              disabled
            />
            <TextField
              label="Name of Father/Guardian"
              fullWidth
              name="fatherName"
              value={formData.fatherName}
              disabled
            />
            <TextField
              label="Address"
              fullWidth
              name="address"
              value={formData.address}
              disabled
            />
            <TextField
              label="RST"
              fullWidth
              name="rst"
              value={formData.rst}
              disabled
            />

            {/* <FormControl fullWidth>
              <Select
                value={
                  filteredGroups.includes(selectedGroupName)
                    ? selectedGroupName
                    : ""
                }
                onChange={handleGroupNameChange}
                required
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredGroups.length > 0 ? (
                  filteredGroups.map((group) => (
                    <MenuItem key={group} value={group}>
                      {group}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Group Names Available</MenuItem>
                )}
              </Select>
            </FormControl> */}

            <FormControl fullWidth>
              <InputLabel>Select GroupName</InputLabel>
              <Select
                value={
                  filteredGroups.includes(selectedGroupName)
                    ? selectedGroupName
                    : ""
                }
                onChange={handleGroupNameChange}
                label="Select GroupName"
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredGroups.length > 0 ? (
                  filteredGroups.map((group) => (
                    <MenuItem key={group} value={group}>
                      {group}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Group Names Available</MenuItem>
                )}
              </Select>
            </FormControl>

            {/* <FormControl fullWidth>
              <Select
                name="propertyPhase"
                value={formData.propertyPhase}
                onChange={handleChange}
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredPhases.map((phase, index) => (
                  <MenuItem key={index} value={phase}>
                    {phase}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <FormControl fullWidth>
              <InputLabel>Select Phase</InputLabel>
              <Select
                value={formData.propertyPhase}
                onChange={handleChange}
                label="Select Phase"
                name="propertyPhase"
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredPhases.length > 0 ? (
                  filteredPhases.map((phase, index) => (
                    <MenuItem key={index} value={phase}>
                      {phase}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Phase Available</MenuItem>
                )}
              </Select>
            </FormControl>

            {/* <FormControl fullWidth>
              <Select
                name="plotPurchased"
                label="Select GroupName"
                value={formData.plotPurchased}
                onChange={handleChange}
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredPlots.map((plot) => (
                  <MenuItem key={plot.id} value={plot.id}>
                    {plot.plotNumber}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <FormControl fullWidth>
              <InputLabel>Select Plot Number</InputLabel>
              <Select
                value={formData.plotPurchased}
                onChange={handleChange}
                label="Select Plot Number"
                name="plotPurchased"
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {filteredPlots.length > 0 ? (
                  filteredPlots.map((plot) => (
                    <MenuItem key={plot.id} value={plot.id}>
                      {plot.plotNumber}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Plots Available</MenuItem>
                )}
              </Select>
            </FormControl>

            <TextField
              label="Total Plot Amount"
              fullWidth
              name="totalPlotAmount"
              value={formData.totalPlotAmount}
              disabled
            />

            <TextField
              label="Total EMI's Selected"
              type="number"
              fullWidth
              name="selectedEmiMonths"
              value={formData.selectedEmiMonths}
              onChange={handleChange}
            />
            <TextField
              label="Amount Paid Till Date"
              fullWidth
              name="amountPaid"
              value={formData.amountPaid}
              onChange={handleChange}
            />

            <TextField
              label="Total EMI’s Paid till Date"
              fullWidth
              name="totalEmisPaid"
              value={formData.totalEmisPaid}
              onChange={handleChange}
            />
            <TextField
              fullWidth
              name="plotPurchasedDate"
              value={formData.plotPurchasedDate}
              onChange={handleChange}
              type="date"
            />
            <TextField
              label="Remaining Amount"
              fullWidth
              name="remainingAmount"
              value={formData.remainingAmount}
              disabled
            />
            <FormControl fullWidth>
              <InputLabel>Select Incentive</InputLabel>
              <Select
                value={selectedIncentive}
                onChange={(e) => setSelectedIncentive(e.target.value)}
                label="Select Incentive Plan"
                MenuProps={{
                  disableScrollLock: true,
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onClick: (event) => {
                      event.stopPropagation();
                    },
                  },
                }}
              >
                {incentivelist.length > 0 ? (
                  incentivelist.map((incentiveitem) => (
                    <MenuItem key={incentiveitem.id} value={incentiveitem.name}>
                      {incentiveitem.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No incentivePlan available</MenuItem>
                )}
              </Select>
            </FormControl>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center" }}
            >
              <Button variant="contained" onClick={handleCustomerPropertyAdd}>
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Base>
  );
};

export default AddCustomerProperty;
